const HISTORICO_ACESSO_FIELDS = {
    VISUALIZAR_HISTORICO: 'visualizarHistorico',
    CENTRAL_ATENDIMENTO: 'centralAtendimento',
    CHAVE_HISTORICO: 'chaveHistorico'
};

export default HISTORICO_ACESSO_FIELDS;
